import { render, staticRenderFns } from "./DisplayInformation.vue?vue&type=template&id=62c63e86&"
import script from "./DisplayInformation.vue?vue&type=script&lang=js&"
export * from "./DisplayInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports